import { useState } from "react";
import AuthComp from "../component/AuthComp";
import { Form, Button, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import Func from "../function/Func";

function DeleteAccount() {
  const { t } = useTranslation(); // Use t instead of lang
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState("");
  const [msgError, setMsgError] = useState("");
  const [alertMsg, setAlertMsg] = useState(false);
  const [msgErrorEmail, setMsgErrorEmail] = useState(
    t("Please enter") + " " + t("Email")
  );
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setMsgErrorEmail(Func.verifyEmail(value, t));
    setEmail(value);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (email) {
      let data = {
        Email: email,
      };
      const res = await ApiUtil.postApi(ApiPath.DELETE_USER, data, "POST");
      if (res.IsSuccessfull) {
        setMsgError('')
        setEmail('')
        setAlertMsg(true);
        setValidated(false);
      } else {
        setValidated(false);
        if(res.Result.Errors.length > 0) {
          setMsgError(res.Result.Errors[0].Message);
        }
        setAlertMsg(false);
      }
    }
  };

  return (
      <AuthComp page="" arrowBack={false}>
        <p className="mb-1">{t("Enter the email you want to delete")}</p>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          {/* email */}
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label className="font-SemiBold">{t("Email")}</Form.Label>
            <Form.Control
              type="email"
              placeholder={t("Enter") + " " + t("Email")}
              value={email}
              onChange={handleEmailChange}
              required
              isInvalid={!!msgErrorEmail && email}
            />
            <Form.Control.Feedback
              type={msgErrorEmail !== "" || email === "" ? "invalid" : "valid"}
            >
              {msgErrorEmail}
            </Form.Control.Feedback>
          </Form.Group>

          <Button
            aria-label="Aria label"
            type="submit"
            className="btn-main w-100 mt-4 "
          >
            {t("Delete")}
          </Button>

          {alertMsg && (
            <Alert variant={"success"} className="mt-3 py-2">
              {t("Account deleted successfully")}
            </Alert>
          )}
          {msgError !== "" && (
            <Alert variant={"danger"} className="mt-3 py-2">
              {t(msgError)}
            </Alert>
          )}
        </Form>
      </AuthComp>

  );
}

export default DeleteAccount;
